import { render, staticRenderFns } from "./ModalTrace.vue?vue&type=template&id=40c2cc14&"
import script from "./ModalTrace.vue?vue&type=script&lang=js&"
export * from "./ModalTrace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40c2cc14')) {
      api.createRecord('40c2cc14', component.options)
    } else {
      api.reload('40c2cc14', component.options)
    }
    module.hot.accept("./ModalTrace.vue?vue&type=template&id=40c2cc14&", function () {
      api.rerender('40c2cc14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/shared/ModalTrace.vue"
export default component.exports